// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import { IconButton } from '@mui/material';
import { Button } from 'components/Buttons';
import { palette, pxToEm, theme } from 'theme';

export const Wrapper = styled.div<{ isActive: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: ${palette.common.white};
  display: ${({ isActive }) => (isActive ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${pxToEm(16)} 0;
  box-sizing: border-box;
  overflow: hidden;
  touch-action: none;
  transition: opacity 0.3s;
  opacity: ${({ isActive }) => (isActive ? 1 : 0)};

  ${theme.breakpoints.down('md')} {
    z-index: 9999999; // to overlay "Help/Chat" button on mobile devices
  }
`;

export const Viewport = styled.div`
  overflow: hidden;
  flex: 1;
  display: flex;
`;

export const Container = styled.div`
  display: flex;
  touch-action: pan-y;
  margin-bottom: ${pxToEm(46)};
`;

export const ActionButtons = styled.div`
  position: absolute;
  top: ${pxToEm(16)};
  right: ${pxToEm(16)};
  z-index: 1;
  display: flex;
  align-items: center;
  gap: ${pxToEm(12)};
`;

export const CloseButton = styled(IconButton)`
  background-color: ${palette.secondary.main};
  border-radius: 50%;

  ${theme.breakpoints.down('md')} {
    padding: 0;
  }
`;

export const SaveToBoardButton = styled(Button)``;

export const Slide = styled.div`
  flex: 0 0 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 ${pxToEm(16)};
  box-sizing: border-box;
  position: relative;

  img {
    max-width: 100%;
    max-height: 100%;
    border-radius: ${pxToEm(20)};
  }
`;

export const Thumbs = styled.div`
  margin-top: auto;

  ${theme.breakpoints.down('md')} {
    width: 100%;
    padding: 0 ${pxToEm(16)};
  }
`;

export const ThumbsViewport = styled.div`
  overflow: hidden;
`;

export const ThumbsContainer = styled.div`
  display: flex;
  touch-action: pan-y;
`;

export const Thumb = styled.div<{ selected: boolean }>`
  flex: none;
  width: ${pxToEm(64)};
  height: ${pxToEm(64)};
  padding: ${pxToEm(4)};
  cursor: pointer;
  overflow: hidden;
  border: ${({ selected }) =>
    selected ? `${pxToEm(2)} solid ${palette.grey['A400']}` : 'none'};
  border-radius: ${pxToEm(12)};
  padding: ${pxToEm(2)};

  ${theme.breakpoints.down('md')} {
    width: ${pxToEm(48)};
    height: ${pxToEm(48)};
    padding: ${pxToEm(2)};
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: ${pxToEm(8)};
  }
`;
